import { SSEService } from '@/shared/services/sse';

export const SSECoreReconfigureChannel = SSEService.createEventChannel('reconfigure');
